











































import {Component, Prop, Mixins, Watch, Vue} from 'vue-property-decorator';
import {Actions, FormModes, Mutations} from '@/ts/store/Constants';
import Flyout from '@/components/Overlays/Flyout.vue';
import Comments from '@/components/Admin/Panels/Notifications/Comments.vue';
import MaterialTabs from '@/components/Tabs/MaterialTabs.vue';
import EventForm from '@/components/Admin/Forms/EventForm.vue';
import BroadcastsEventsMethods from '@/mixins/BroadcastsEventsMethods.vue';
import EntitySocialMethods from '@/mixins/EntitySocialMethods.vue';
import ChatMessageInput from '@/components/Chat/ChatMessageInput.vue';
import Attendees from '@/components/Admin/Panels/Notifications/Attendees.vue';
import CalendarEventData from '@/ts/CalendarEventData';
import EventAttendees from '@/ts/EventAttendees';

@Component({
    components: {
        Flyout,
        MaterialTabs,
        EventForm,
        Comments,
        ChatMessageInput,
        Attendees,
    },
})
export default class EventFlyout extends Mixins(EntitySocialMethods, BroadcastsEventsMethods) {
    @Prop({ default: 'create' }) public formMode: string;

    public activeTab: string = 'information';
    public activeComponent: string = 'EventForm';
    public eventWithPublishedDate: boolean = false;

    public tabs: any = [
        {
            title: this.$t('general.event-information', 'Event information'),
            value: 'information',
            icon: 'far fa-calendar-alt',
            component: 'EventForm',
        },
        {
            title: `${this.$t('general.attendees', 'Attendees')} (${this.isEditing ? '0' : this.$t('general.na', 'N/A')})`,
            value: 'attendees',
            icon: 'far fa-users',
            component: 'Attendees',
            disabled: this.isCreating,
        },
        {
            title: `${this.$t('general.comments-na', 'Comments')} (${this.isCreating ? this.$t('general.na', 'N/A') : 0})`,
            value: 'comments',
            icon: 'fal fa-comment-alt',
            badge: null,
            component: 'Comments',
            disabled: this.isCreating || this.isEventPending,
        },
    ];

    get event(): CalendarEventData {
        return this.$store.getters['Events/activeEvent'];
    }

    get isEditing(): boolean {
        return this.formMode === FormModes.Edit;
    }

    get isCreating(): boolean {
        return this.formMode === FormModes.Create;
    }

    get attendees(): EventAttendees[] {
        return this.$store.getters['Events/getAttendees'];
    }

    get attendeesCount(): number {
        return this.attendees.filter((attendee: EventAttendees) => attendee.answer).length;
    }

    get modalTitle(): string {
        return this.isCreating
            ? this.$t('general.create-new-event', 'Create new event')
            : this.$t('general.edit-event-post', 'Edit event post');
    }

    get isEventPending(): boolean {
        return this.event.publishedAt !== null && !this.event.queueIsExecuted;
    }

    public configureAttendeesTabTitle() {
        if (this.tabs) {
            const commentsTab = this.tabs.find((tabObj: any) => tabObj.value === 'attendees');
            commentsTab.title = `${this.$t('general.attendees', 'Attendees')} (${this.isCreating ? this.$t('general.na', 'N/A') : this.attendeesCount})`;
        }
    }

    public eventPublishDateChanged(publishedAt: any) {
        this.eventWithPublishedDate = publishedAt !== null;
    }

    @Watch('attendees')
    public attendeesChanged() {
        this.configureAttendeesTabTitle();
    }

    @Watch('commentsConversation.comments')
    public commentsAreLoaded() {
        this.hasUnreadComments =  this.commentsConversation ? this.commentsConversation.hasNewComments > 0 : false;

        this.configureCommentsTabTitle();
        this.configureCommentsTabBadge();

        Vue.nextTick(() => {
            if (this.activeTab === 'comments') {
                this.scrollToBottom('broadcast-comments');
            }
        });
    }

    public handleSendMessage(message: string) {
        this.$store.dispatch(Actions.ADD_COMMENT, {
            conversationId: this.commentsConversation.id,
            message,
            notificationId: this.commentsConversation.notification_id,
            eventId: this.event.id,
        }).then(() => {
            this.scrollToBottom('broadcast-comments');
            this.configureCommentsTabTitle();
        });
    }

    public configureCommentsTabBadge() {
        if (this.tabs) {
            const commentsTab = this.tabs.find((tabObj: any) => tabObj.value === 'comments');
            commentsTab.badge = this.hasUnreadComments ? 'normal' : null;
        }
    }

    public configureCommentsTabTitle() {
        if (this.tabs) {
            const commentsTab = this.tabs.find((tabObj: any) => tabObj.value === 'comments');
            commentsTab.title = `${this.$t('general.comments-na', 'Comments')} (${this.isCreating ? this.$t('general.na', 'N/A') : this.commentsCount})`;
        }
    }

    public close() {
        if (this.commentsConversation) {
            this.$store.dispatch(Actions.CLOSE_COMMENTS_SOCKET, {vue: this, conversationId: this.commentsConversation.id});
        }

        (this.$refs.flyoutComponent as any).close();
    }

    public mounted() {
        if (this.isEditing) {
            if (this.event.notificationId !== null) {
                this.showComments('notification', this.event.notificationId);
            }

            this.$store.dispatch(Actions.FETCH_EVENT_ATTENDEES, {
                eventId: this.event.id,
                type: 'admin',
            });
        }
    }

    public destroyed() {
        this.$store.commit(Mutations.RESET_EVENT_ATTENDEES);
        this.$store.commit(Mutations.RESET_COMMENTS);
    }
}
